import styled from 'styled-components';

export const Card = styled.div`
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background: white;
  @media (min-width: 768px) {
    padding: 1.2rem;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  color: #333;
`;

export const MessageText = styled.p`
  font-size: 0.95rem;
  margin: 0;
  color: #333;
  span {
    font-weight: bold;
  }
`;

export const SubjectText = styled.p`
  font-size: 1rem;
  margin: 0;
  font-weight: bold;
  color: #333;
`;

export const Button = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'acknowledged'
})<{ acknowledged: boolean }>`
  align-self: flex-start;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 0.85rem;
  text-transform: lowercase;
  background-color: ${({ acknowledged }) => (acknowledged ? '#1e7f42' : '#8b0000')};
  cursor: ${({ acknowledged }) => (acknowledged ? 'not-allowed' : 'pointer')};
  ${({ acknowledged }) =>
    !acknowledged &&
    `
    &:hover {
      background-color: #a30000; // Darker shade for hover effect
    }
  `}
`;
